export type PlayerVideoMetadata = {
  mediaUrl: string;
  sourceLabel: string | null;
};

export function nhlHeadshotUrl(nhlId: number | null | undefined): string | null {
  return nhlId ? `https://assets.nhle.com/mugs/nhl/latest/${nhlId}.png` : null;
}

export function normalizeHttpUrl(value: string | null | undefined): string | null {
  const trimmed = value?.trim();
  if (!trimmed) return null;
  try {
    const url = new URL(trimmed);
    return url.protocol === 'http:' || url.protocol === 'https:' ? url.toString() : null;
  } catch {
    return null;
  }
}

export function buildPlayerVideoMetadata(
  mediaUrl: string | null | undefined,
  sourceLabel: string | null | undefined
): string | null {
  const normalizedUrl = normalizeHttpUrl(mediaUrl);
  if (!normalizedUrl) return null;
  return JSON.stringify({
    mediaUrl: normalizedUrl,
    sourceLabel: sourceLabel?.trim() || null,
  } satisfies PlayerVideoMetadata);
}

export function parsePlayerVideoMetadata(
  value: string | null | undefined
): PlayerVideoMetadata | null {
  if (!value) return null;
  try {
    const parsed = JSON.parse(value) as Record<string, unknown>;
    const mediaUrl = normalizeHttpUrl(typeof parsed.mediaUrl === 'string' ? parsed.mediaUrl : null);
    if (!mediaUrl) return null;
    return {
      mediaUrl,
      sourceLabel:
        typeof parsed.sourceLabel === 'string' && parsed.sourceLabel.trim()
          ? parsed.sourceLabel.trim()
          : null,
    };
  } catch {
    return null;
  }
}
